import type { Handicap } from '../types';

/**
 * Les trois situations, dans l'ordre ou l'ecole les enonce.
 *
 * Hors du composant de saisie : la liste et son libelle servent aussi a
 * l'affichage (la pastille de la fiche), et un fichier qui exporte a la
 * fois un composant et des constantes casse le rafraichissement a chaud.
 */
export const HANDICAPS: { code: Handicap; libelle: string }[] = [
  { code: 'handicap', libelle: 'Handicap' },
  { code: 'dys', libelle: 'Trouble dys-' },
  { code: 'tdah', libelle: 'TDAH' },
];

export function libelleHandicap(code: Handicap): string {
  return HANDICAPS.find((candidat) => candidat.code === code)?.libelle ?? code;
}
